import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const MicroFrontendExample = lazyWithRetry(() => import('./MicroFrontendExample'));
type Props = RouteComponentProps;

const MicroFrontendExampleRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="micro-frontend-example">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <MicroFrontendExample />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default MicroFrontendExampleRoutes;
